
import Vue, { defineComponent } from "vue";
export default defineComponent({
  name: "musicSvg",
  components: {},
  props: {
    color: {
      type: String,
      default: "red",
    },
  },
});
